export const KIND_LABELS = {
  feed: '吃奶',
  poop: '臭臭',
  pee: '小便',
  sleep: '睡眠',
};

export const FEED_LABELS = {
  breastmilk: '母乳瓶喂',
  formula: '奶粉',
  nursing: '亲喂',
};

export const SIDE_LABELS = { left: '左侧', right: '右侧', both: '双侧' };
export const POOP_LEVELS = ['微量', '少量', '正常', '大量', '海量'];
export const PEE_LEVELS = ['少量', '正常', '大量'];

export function formatClock(value) {
  if (!value) return '--:--';
  return new Intl.DateTimeFormat('zh-CN', {
    timeZone: 'Asia/Shanghai',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(new Date(value));
}

export function formatShortDate(value) {
  if (!value) return '';
  return new Intl.DateTimeFormat('zh-CN', {
    timeZone: 'Asia/Shanghai',
    month: 'numeric',
    day: 'numeric',
  }).format(new Date(value));
}

export function formatDateTime(value) {
  if (!value) return '';
  return new Intl.DateTimeFormat('zh-CN', {
    timeZone: 'Asia/Shanghai',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(new Date(value));
}

export function durationMinutes(event, now = new Date()) {
  if (event.kind !== 'sleep') return 0;
  return Math.max(0, Math.round((new Date(event.endedAt ?? now) - new Date(event.startedAt)) / 60000));
}

export function formatDuration(minutes) {
  const safe = Math.max(0, Math.round(Number(minutes) || 0));
  const hours = Math.floor(safe / 60);
  const rest = safe % 60;
  if (!hours) return `${rest} 分钟`;
  return rest ? `${hours} 小时 ${rest} 分` : `${hours} 小时`;
}

export function eventSummary(event, now = new Date()) {
  if (event.kind === 'feed') {
    const amount = event.unit === 'min' ? `${event.amount} 分钟` : `${event.amount} ml`;
    const side = event.side ? ` · ${SIDE_LABELS[event.side]}` : '';
    return `${FEED_LABELS[event.subtype] ?? '吃奶'} · ${amount}${side}`;
  }
  if (event.kind === 'poop') return `臭臭 · ${POOP_LEVELS[event.amount - 1] ?? '已记录'}`;
  if (event.kind === 'pee') return `小便 · ${PEE_LEVELS[event.amount - 1] ?? '已记录'}`;
  if (event.kind === 'sleep') {
    return event.endedAt ? `睡眠 · ${formatDuration(durationMinutes(event, now))}` : '正在睡眠';
  }
  return '记录';
}

export function toDateTimeLocal(value) {
  const date = value ? new Date(value) : new Date();
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Shanghai',
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hour12: false,
  }).formatToParts(date);
  const values = Object.fromEntries(parts.map(({ type, value: partValue }) => [type, partValue]));
  return `${values.year}-${values.month}-${values.day}T${values.hour}:${values.minute}`;
}

export function fromDateTimeLocal(value) {
  if (!value) return null;
  return new Date(`${value}:00+08:00`).toISOString();
}

export function babyAge(birthDate, now = new Date()) {
  if (!birthDate) return '尚未设置生日';
  const birth = new Date(`${birthDate}T00:00:00+08:00`);
  const days = Math.max(0, Math.floor((now - birth) / 86400000));
  if (days < 31) return `${days} 天`;
  if (days < 730) return `${Math.floor(days / 30.4375)} 个月`;
  const years = Math.floor(days / 365.25);
  return `${years} 岁`;
}
